// extracted by mini-css-extract-plugin
export default {"mrq_cover_letter_cell":"MrqCoverLetterCell_mrq_cover_letter_cell__vDqof"};